import * as Yup from 'yup'

import { GENDER_OPTION } from '../../../../../ReusableFormFields/GenderFields/fields'

export const validationSchema = Yup.object().shape({
  [GENDER_OPTION]: Yup.string().required('Please selected gender')
})
